import NewTransporter from "../../../components/@logistics/NewTransporter";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function TransporterNewPage() {

    return (
        <NewTransporter 
            routeType={routeTypes.admin}
        />
    )
}       